<template>
  <base-dialog class="select-gateway-insert-type-dialog" width="485px" :visible.sync="visible">
    <template v-slot:header>
      分支设置
    </template>
    <div class="body-wrapper">
      <div>将分支下方的节点</div>
      <el-radio v-model="moveFlag" :label="true">
        移动至左侧分支内
      </el-radio>
      <el-radio v-model="moveFlag" :label="false">
        不移动
      </el-radio>
    </div>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">
        确定
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
export default {
  name: "select-gateway-insert-type-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    return {
      visible: false,
      moveFlag: true
    }
  },
  methods: {
    open() {
      this.moveFlag = true
      this.visible = true
    },
    submit() {
      this.$emit("submit", this.moveFlag)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.select-gateway-insert-type-dialog {
  .body-wrapper {
    display: flex;
    flex-flow: column;
    .el-radio {
      margin-top: 18px;
    }
  }
}
</style>
